import type { Customer } from "@lib/api-services/services/profile-service/types";
import type { StoreState } from "@store/types";
import { applyBaseCustomerFields, applyAdditionalFields } from "./set-profile-helpers";

export const updateProfile = (customer: Customer) => (state: StoreState) => {
    const me = state.data.me;

    if (!me.customer) {
        me.customer = {} as Customer;
    }

    const customerState = me.customer;

    applyBaseCustomerFields(customerState, customer);
    applyAdditionalFields(customerState, customer);
};
